module.exports = __webpack_public_path__ + "static/media/Java.ee486b5e.png";